import React, { Component } from 'react';

export default class PeopleSection extends Component {
  render() {
    const { data } = this.props;
    if (!data.videoEmbed) return null;
    return (
      <div className="section">
        <h3 className="sectiontitle">Learn more</h3>
        <br />
        <div
          className="sectionitem"
          style={{ position: 'relative', maxHeight: '500px' }}
        >
          <div style={{ paddingBottom: '60%' }} />
          <div
            style={{
              position: 'absolute',
              top: '0px',
              left: '0px',
              width: '100%',
              maxWidth: '800px',
              maxHeight: '500px',
              height: '100%',
              borderRadius: '6px',
              overflow: 'hidden',
              boxShadow: '0px 2px 5px #00000040',
            }}
            dangerouslySetInnerHTML={{ __html: data.videoEmbed }}
          />
        </div>
      </div>
    );
  }
}
